module.exports = __webpack_public_path__ + "img/sleepcasts.c2679d19.png";